module.exports = __webpack_public_path__ + "media/images/flags/1x1/hrv-03cc80efca87ac04d66696a8c8853aad.svg";